const allowedAttributes = [ 'src', 'srcset', 'alt', 'title', 'width', 'height', 'loading', 'decoding', 'sizes', 'style' ];

export default {
    allowedAttributes
}